import { render } from "./CartBox.vue?vue&type=template&id=ebb0f72c"
import script from "./CartBox.vue?vue&type=script&lang=js"
export * from "./CartBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__